// Typed extra-contacts (loaner_agents) API. Mirrors the devices api pattern: real backend
// unless VITE_USE_MOCKS is on. All calls are admin-gated (the admin JWT carries the identity).
import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";
import { mockLoanerAgentsApi } from "@/mocks/mockLoanerAgents";
import type { LoanerAgent } from "./types";

export interface LoanerAgentsApi {
  list(loanerId: number): Promise<LoanerAgent[]>;
  add(loanerId: number, body: { email: string; name?: string; phone?: string }): Promise<{ id: number }>;
  revoke(loanerId: number, agentId: number): Promise<void>;
}

const realLoanerAgentsApi: LoanerAgentsApi = {
  async list(loanerId) {
    const r = await apiClient.get<{ ok: true; agents: LoanerAgent[] }>(
      `/admin/loaners/${loanerId}/agents`
    );
    return r.agents;
  },
  async add(loanerId, body) {
    return apiClient.post<{ ok: true; id: number }>(`/admin/loaners/${loanerId}/agents`, body);
  },
  async revoke(loanerId, agentId) {
    await apiClient.post(`/admin/loaners/${loanerId}/agents/${agentId}/revoke`);
  },
};

export const loanerAgentsApi: LoanerAgentsApi = env.useMocks
  ? mockLoanerAgentsApi
  : realLoanerAgentsApi;
